import { FieldInstance } from "../core/components/field";
import { IsNumericTextBox, NumericTextBoxProps } from "../core/components/isNumericTextBox";
import { Dialog, DialogProps } from "../core/components/dialog";
import { ComponentHelper } from "../core/util/componentHelper";
import { Config } from "../core/config/config";
import { ColorPicker, ColorPickerProps } from "../core/components/colorPicker";
import { GeoMapRouteResultGraduation } from "../core/util/resourcePlanningHelper";
import React from "react";
export class UserSettingsGeoMapRouteResultGraduation extends React.Component<UserSettingsGeoMapRouteResultGraduationProps, UserSettingsGeoMapRouteResultGraduationState> {
    private _componentHelper: any;

    private _newActions = [
        {
            label: Config.translations.cancel,
            action: () => {
                () => { };
            }
        },
        {
            label: Config.translations.saveLabel,
            action: () => {
                return this._saveRouteResultGraduation();
            },
            primary: true
        }
        ];

    private _editActions = [
        {
            label: Config.translations.cancel,
            action: () => {
                () => {
                };
            }
        },
        {
            label: Config.translations.saveLabel,
            action: () => {
                return this._saveRouteResultGraduation();
            },
            primary: true
        },
        {
            label: Config.translations.delete,
            action: () => {
                this._deleteRouteResultGraduation();
            },
            primary: true
        }
        ];


    constructor(props) {
        super(props);
        this._componentHelper = ComponentHelper.createFactory();
        const threshold = this.props.geoMapRouteResultGraduation ? this.props.geoMapRouteResultGraduation.threshold : null;
        const color = this.props.geoMapRouteResultGraduation ? this.props.geoMapRouteResultGraduation.color : null;
        const id = this.props.geoMapRouteResultGraduation ? this.props.geoMapRouteResultGraduation.id : null;
        this.state = { threshold: threshold, color: color, dialogOpen: this.props.dialogOpen, id: id };
    }

    private _saveRouteResultGraduation = () => {
        this.props.saveRouteResultGraduation({ threshold: this.state.threshold, color: this.state.color, id: this.state.id });
    }

    private _deleteRouteResultGraduation = () => {
        this.props.deleteRouteResultGraduation(this.state.threshold);
    }

    private _setOpenStatus = (status: boolean) => {
        this.props.setOpenStatus(status);
    }

    getNumericTextBoxProps = () => {
        let numericTextBoxProps: NumericTextBoxProps = this._componentHelper.getDefaultNumericTextBoxProps();
        numericTextBoxProps.field.min = 0;
        numericTextBoxProps.onChange = this.thresholdOnChange;
        numericTextBoxProps.value = this.state.threshold;
        return numericTextBoxProps;
    }

    getColorPickerProps = () => {
        let colorPickerProps: ColorPickerProps = this._componentHelper.getDefaultColorPickerProps();
        colorPickerProps.onChange = this.colorOnChange;
        colorPickerProps.value = this.state.color;
        return colorPickerProps;
    }

    getDialogProps = () => {
        return {
            title: this.props.translations["GeoMap.Settings.RouteGraduation"],
            actions: this.props.geoMapRouteResultGraduation ? this._editActions : this._newActions,
            afterClose: () => {
                this._setOpenStatus(false);
            },
            width: 500,
            open: true
        } as DialogProps;
    }

    thresholdOnChange = (field: { model: string }, value: any, dataItem?: any) => {
        this.setState({ threshold: value });
    }

    colorOnChange = (field: { model: string }, value: any, dataItem?: any) => {
        this.setState({ color: value });
    }

    static getDerivedStateFromProps(props: UserSettingsGeoMapRouteResultGraduationProps, state: UserSettingsGeoMapRouteResultGraduationState) {
        if (props.dialogOpen !== state.dialogOpen) {
            return {
                dialogOpen: props.dialogOpen,
                threshold: props.geoMapRouteResultGraduation ? props.geoMapRouteResultGraduation.threshold : null,
                color: props.geoMapRouteResultGraduation ? props.geoMapRouteResultGraduation.color : null,
                id: ((props.geoMapRouteResultGraduation ? props.geoMapRouteResultGraduation.id : null) || kendo.guid())
            } as UserSettingsGeoMapRouteResultGraduationState;
        }
        return null;
    }

    render() {
        return (this.props.dialogOpen
            ? <Dialog {...this.getDialogProps()}>
                <FieldInstance label={this.props.translations["GeoMap.Settings.MaxKm"]} labelStyle={{ width: "200px" } as React.CSSProperties} noHover={true} >
                    <IsNumericTextBox {...this.getNumericTextBoxProps()} />
                </FieldInstance>
                <FieldInstance label={this.props.translations["Standard.Farbe"]} labelStyle={{ width: "200px" } as React.CSSProperties} noHover={true} >
                    <ColorPicker {...this.getColorPickerProps()} />
                </FieldInstance>
            </Dialog>
            : null
        );
    }
}

export interface UserSettingsGeoMapRouteResultGraduationProps {
    geoMapRouteResultGraduation?: GeoMapRouteResultGraduation;
    dialogOpen: boolean;
    translations: Array<any>;//StringKeyDictionary<string>;
    saveRouteResultGraduation: (geoMapRouteResultGraduation: GeoMapRouteResultGraduation) => void;
    deleteRouteResultGraduation: (threshold: number) => void;
    setOpenStatus: (status: boolean) => void;
}

export interface UserSettingsGeoMapRouteResultGraduationState {
    threshold?: number;
    color?: string;
    dialogOpen?: boolean;
    id: string;
}
